import Nav from "@/components/thoratech/Nav";
import Hero from "@/components/thoratech/Hero";
import {
  Difference,
  Services,
  HowWeRunIt,
  WhyUs,
} from "@/components/thoratech/CoreSections";
import Channels from "@/components/thoratech/Channels";
import Industries from "@/components/thoratech/Industries";
import {
  SuccessStory,
  About,
  EngagementModel,
  ProgressKode,
} from "@/components/thoratech/ProofSections";
import Contact from "@/components/thoratech/Contact";
import Footer from "@/components/thoratech/Footer";
import Seo from "@/seo/Seo";

export default function ThoratechSite() {
  return (
    <main data-testid="thoratech-page" className="bg-white text-[#01080E]">
      <Seo route="/" />
      <Nav />
      <Hero />
      <Difference />
      <Services />
      <HowWeRunIt />
      <Channels />
      <WhyUs />
      <Industries />
      <SuccessStory />
      <About />
      <EngagementModel />
      <ProgressKode />
      <Contact />
      <Footer />
    </main>
  );
}
